import { render, staticRenderFns } from "./Lookups.vue?vue&type=template&id=2f95a150&"
import script from "./Lookups.vue?vue&type=script&lang=ts&"
export * from "./Lookups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports